<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>For my mother, with love, and in memory of Patsy</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?4a319e5b